import Vuex from 'vuex'
import Vue from 'vue'
import util from '../utils/index.js'
Vue.use(Vuex);
const platform = util.getPlatform();
const searchCodes = util.URLSearchCodes;

const state = {
  platform,
  searchCodes,
  hasGesture: false,
  pageTitle: '',
  contentMarginTop: 120,
  contentMarginBottom: 60,
  headFooterStyle: {},
  htmlFontSize: 100,
  indexCardsSize: {
    'baseGrid': {
      margin: 0.1,
      width: 2.90,
      height: 4.16
    },
    'normal': {
      margin: 0.1,
      width: 2.90,
      height: 4.16
    },
    'large': {
      margin: 0.1,
      width: 5.90,
      height: 4.16
    },
    'max': {
      margin: 0.1,
      width: 5.90,
      height: 8.42
    }
  },
  individuationSetting: {
    configCode: '',
    pageName: '',
    pageTitle: '',
    pageLogo: '',
    pageLogoType: null,
    pageBg: '',
    signature1: '',
    signature2: '',
    signature3: ''
  },
  zoomImgObj: {
    url: '',
    show: false,
    width: 0,
    height: 0
  }
}

const getters = {
  individuationBg: (state) => {
    return state.individuationSetting.pageBg
  }
}

const mutations = {
  setState(state, payload){
    if (payload && payload.name) {
      state[payload.name] = payload.value
    }
  },
  changeGestureState(state, payload){
    state.hasGesture = payload
  },
  resizeCardsSize(state, payload){
    // 60 为content区上下padding之和，1080为一体机高度
    let htmlFontSize = (window.innerHeight - state.contentMarginTop - state.contentMarginBottom - 60) / (1080 - state.contentMarginTop - state.contentMarginBottom - 60) * 100;
    htmlFontSize = htmlFontSize > 55 ? htmlFontSize : 55;
    state.htmlFontSize = htmlFontSize;
    document.documentElement.style.fontSize = htmlFontSize + 'px';
  },
  /**一体机自定义配置
   * @method  setIndividuation
   * @author sansengg
   * @version 2017-05-04
   * @param   {[type]}         state              [description]
   * @param   {[type]}         options.pageName   [description]
   * @param   {[type]}         options.pageTitle  [description]
   * @param   {[type]}         options.pageBg     [description]
   * @param   {[type]}         options.signature1 [description]
   * @param   {[type]}         options.signature2 [description]
   * @param   {[type]}         options.signature3 [description]
   */
  setIndividuation(state, {pageName, pageTitle, pageBg, pageLogo, pageLogoType, signature1 = '', signature2, signature3}){
    state.individuationSetting.pageName = pageName
    state.individuationSetting.pageTitle = pageTitle
    state.individuationSetting.pageLogo = pageLogo
    state.individuationSetting.pageLogoType = pageLogoType
    state.individuationSetting.pageBg = pageBg
    state.individuationSetting.signature1 = signature1
    state.individuationSetting.signature2 = signature2
    state.individuationSetting.signature3 = signature3
  },
  setPageTitle(state, payload){
    let productName = localStorage.getItem('ProductName') || '';
    if (productName.length > 15) {
      productName = productName.slice(0, 15) + '...'
    }
    state.pageTitle = productName + ' · ' + payload;
    if (productName.length === 0) {
      state.pageTitle = payload;
    }
  },
  setZoomImg(state, payload){
    state.zoomImgObj = payload || {};
  }
}
export default new Vuex.Store({
  state,
  getters,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js